module.exports = __webpack_public_path__ + "img/no-order.37fdf12d.png";